<!--
트래킹번호 수정
------------------------------------
-->
<template>
    <!-- 모달 -->
    <div class="uk-modal-full" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
            <div uk-grid class="uk-grid-small uk-padding" uk-height-viewport>

                
                <div class="uk-card uk-card-default uk-card-body uk-card-small uk-width-medium">
                    <!-- 대기화면 -->
                    <div v-show="jobState === 'ready'">
                        <p class="uk-text-center uk-text-primary uk-text-large">
                            선택한 상품의 트래킹번호를 일괄 입력합니다
                        </p>

                        <app-input-ex
                                class="uk-margin"
                                type="text"
                                label="트래킹번호"
                                placeholder="트래킹번호를 입력하세요"
                                v-model="inputTrackingNo"
                        ></app-input-ex>

                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large"
                                type="button"
                                v-on:click="jobStart()"
                            >
                                <span uk-icon="icon: play"></span>
                                작업시작
                            </button>
                        </div>



                        
                    </div>

                    <!-- 입력값 표시 -->
                    <div v-show="jobState !== 'ready'" class="">
                        <span class="uk-text-meta">트래킹번호</span>
                        <span class="uk-text-primary">{{ inputTrackingNo }}</span>
                        <hr />
                    </div>


                    <!-- 실행중 -->
                    <div v-show="jobState === 'doing'">
                        <p class="uk-text-center uk-text-danger uk-text-large">
                            "작업이 진행중입니다. 작업이 종료될때까지 브라우저를 닫지마세요"
                        </p>
                    </div>
                    
                    <!-- 완료 -->
                    <div v-show="jobState === 'done'">
                        <p class="uk-text-center uk-text-primary uk-text-large">
                            "작업이 완료되었습니다. 브라우저를 닫아도 좋습니다."
                        </p>

                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large"
                                type="button"
                                v-on:click="refreshPage()"
                            >
                                <span uk-icon="icon: refresh"></span>
                                현재 페이지 새로고침
                            </button>
                        </div>
                    </div>

                    

                </div>

                
        
                <div class="uk-width-3-4@l uk-margin-top">
                    <!-- 진행률 -->
                    <div class="uk-text-large uk-text-primary uk-margin-left">
                        {{ successCount }} / {{ targetCount }}
                        <span v-show="failCount > 0" class="uk-text-danger">(실패 : {{ failCount }})</span>
                    </div>
                    <progress id="js-progressbar" class="uk-progress uk-margin-remove" :value="successCount" :max="targetCount" ></progress>



                    <!-- 리스트 -->
                    <table class="uk-table uk-table-small uk-table-middle app-prod-table uk-margin-top">
                        <colgroup>
                            <col style="width: 8rem">

                            <col style="width: 10rem">

                            <col style="width: 8rem">
                            <col style="width: 15rem">
                            <col style="width: 10rem">


                            <col style="width: 5rem">
                            <col style="width: 10rem">
                            <col style="width: 60px">

                            <col>


                        </colgroup>

                        <thead>
                        <tr>

                            <th scope="col" class="uk-text-center">
                                진행상태
                            </th>


                            <th scope="col" class="uk-text-center">
                                회원사/수취인
                            </th>

                            <th scope="col" class="uk-text-center">
                                상품번호
                            </th>
                            <th scope="col" class="uk-text-center">
                                해외오더/트래킹
                            </th>
                            <th scope="col" class="uk-text-center">
                                배송단계
                            </th>


                            <th scope="col" class="uk-text-center">
                                수량
                            </th>
                            <th scope="col" class="uk-text-center">
                                옵션/구입단가
                            </th>
                            <th scope="col" class="uk-text-center">
                                이미지
                            </th>

                            <th scope="col" class="uk-text-left">
                                상품명
                            </th>


                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="target in jobTargets">
                            <td class="uk-text-center">
                                <div v-show="target.state === 'ready'" class="uk-text-muted">
                                    대기
                                </div>
                                <div v-show="target.state === 'doing'" class="uk-text-primary">
                                    <span uk-icon="icon: play"></span>
                                    처리중..
                                </div>
                                <div v-show="target.state === 'success'" class="uk-text-success">
                                    <span uk-icon="icon: check"></span>
                                    성공
                                </div>
                                <div v-show="target.state === 'fail'" class="uk-text-danger">
                                    <span uk-icon="icon: close"></span>
                                    실패
                                </div>

                                <!-- 작업메세지 -->
                                <div v-show="target.job_msg" class="uk-text-meta">
                                    {{ target.job_msg }}
                                </div>
                            </td>


                            <td class="uk-text-center">
                                <div title="회원사" class="uk-margin-small-bottom">
                                    {{ target.item.user_nick }}
                                </div>
                                <div title="수취인">
                                    {{ target.item.h_name }}
                                </div>
                                <div title="배송코드">
                                    {{ target.item.house_code }}
                                </div>
                            </td>


                            <td class="uk-text-center">
                                {{ target.item.id }}

                                <!-- 상세링크 -->
                                <a
                                    class="uk-link-reset uk-button uk-button-small uk-button-white uk-margin-small-top"
                                    :href="'/prods/'+target.item.id"
                                    target="_blank"
                                >상세</a>
                            </td>
                            <td class="uk-text-left">
                                <div>
                                    <i class="material-icons md-18">receipt</i>
                                    {{ target.item.buy_order_code }}
                                </div>
                                <div>
                                    <i class="material-icons md-18">local_shipping</i>
                                    {{ target.item.tracking_no }}
                                </div>
                            </td>
                            <td class="uk-text-center">
                                {{ target.item.state_text }}
                            </td>



                            <td class="uk-text-center">
                                {{ target.item.amount }}
                            </td>
                            <td class="uk-text-center">
                                <div title="색상">{{ target.item.color }}</div>
                                <div title="사이즈" class="uk-margin-small-bottom">{{ target.item.size }}</div>
                                <div title="구입단가">{{ target.item.buy_unit_price_text }}</div>
                                <div title="마켓 판매단가">{{ target.item.hp_order_unit_price_krw_text }}</div>
                            </td>
                            <td class="uk-text-center">
                                <img :src="target.item.img_url" width="50" />
                            </td>


                            <td class="uk-text-left">
                                {{ target.item.name }}
                            </td>



                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    export default {
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,

        },
        data: function () {
            
            return {
                /**
                 * 현재 작업진행상태 
                 *  - none : 작업 초기화되지 않은상태 (모달창 뜨지 않음)
                 *  - ready : 작업 대기중
                 *  - doing : 진행중
                 *  - done : 완료
                 */
                jobState: 'ready',

                /**
                 * 작업대상 (작업상태 와 실제 작업대상이되는 아이템정보를 가진다.)
                 *  - 작업이 초기화될때, 작성된다.
                 * [
                 *  {state: 'success', job_msg: '작업관련 메세지(성공/실패)', item: {실제아이템정보}, next: {다음아이템포인터}},
                 *  {state: 'fail', ...},
                 *  {state: 'doing', ...},
                 *  {state: 'ready', ...},
                 * ]
                 */
                jobTargets: [],

                // 입력값-트래킹번호
                inputTrackingNo: '',

            };
        },
        computed: {
            // 작업대상 전체 카운트
            targetCount() {
                return this.jobTargets.length;
            },

            // 작업성공 카운트
            successCount() {
                return _.filter(this.jobTargets, ['state', 'success']).length;
            },

            // 작업실패 카운트
            failCount() {
                return _.filter(this.jobTargets, ['state', 'fail']).length;
            },
        },
        methods: {
            // 작업초기화 (모달창이 띄워지는 순간 초기화작업)
            jobInit() {
                // 진행상태
                this.jobState='ready';

                // 작업대상아이템 배열작성
                let targets = _.map(this.batch.checked_items, item => {
                    return {
                        state: 'ready',
                        job_msg: null,
                        item: item
                    };
                });

                // 작업대상 아이템에 next 연결
                for (let i=0; i < targets.length; i++) {
                    let curr = targets[i];
                    let next = targets[i+1];
                    curr.next = next ? next : null; // 다음아이템없으면 널
                }
                this.jobTargets = targets;
                //console.log(this.jobTargets);

                // 모달창
                UIkit.modal(this.$el).show();
            },

            // 작업시작
            jobStart() {
                // 컨펌
                if (! confirm(this.targetCount+' 개 상품의 트래킹번호가 일괄입력됩니다. 정말 실행합니까?')) {
                    return;
                }

                // 진행상태
                this.jobState='doing';

                // 첫번째 작업대상의 작업실행
                this.workOneTarget(this.jobTargets[0]);
            },

            // 작업완료
            jobDone() {
                // 진행상태
                this.jobState='done';
            },

            // 현재페이지 갱신
            refreshPage() {
                $.app.refresh();
            },

            /**
             * 하나의 작업대상에 대한 작업을 실행
             * @param target 작업대상 (jobTargets 배열의 아이템)
             */
            workOneTarget(target) {
                // 클로저 위해서 정의
                let cmp = this;


                // ajax 옵션
                let opts = {
                    type: 'PATCH',
                    url: '/prods/'+target.item.id+'/tracking-no',
                    data: {
                        _token: cmp.csrfToken,
                        tracking_no: cmp.inputTrackingNo,
                    },
                    dataType: 'json',
                    success: function (response, textStatus, jqXHR) {
                        // 성공으로 설정
                        target.state = 'success';
                        target.job_msg = response.msg;
                        target.item.tracking_no = response.updated_val;
                    },
                    alert_error_msg: function(msg){
                        // 실패로 설정
                        target.state = 'fail';
                        target.job_msg = msg;
                    },
                    complete: function(jqXHR, textStatus){
                        // 다음타겟 호출
                        let next = cmp.findNextTargetToWork(target)
                        if (next) {
                            cmp.workOneTarget(next);
                        } else {
                            // 다음없으면, 전체작업 완료처리
                            cmp.jobDone();
                        }

                    }
                };
                // ajax 실행
                $.app.ajax.module.default(opts);
            },


            /**
             * 주어진 target 으로부터 작업을 위한 다음 target을 반환
             * @return 다음타겟이 없으면 null반환
             */
            findNextTargetToWork: function (target) {
                let next = target.next;

                if (! next) {
                    return null;
                }

                //console.log(next.item.id+':'+next.state);
                if (next.state === 'ready') {
                    // 대기상태만 반환
                    return next;
                } else {
                    // 다음 타겟이 대기상태가 아니면, 계속 넘김
                    return this.findNextTargetToWork(next);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>